import React, { useState } from "react"; // eslint-disable-line no-unused-vars
import {
  Grid2 as Grid,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Donation, CodeDetails, Settings } from "../types";
import { convertToCurrency } from "../utilities/tools";
import { Redeem as RedeemIcon } from "@mui/icons-material";
import { RequiredTextField, OptionalTextField } from "../components";
import {
  isDonationAmountValid,
  getDonationAmountErrors,
} from "../utilities/validators";

export interface DonationAmountProps {
  codeDetails: CodeDetails;
  settings: Settings;
  donation: Donation;
  currentDonationAmount: number;
  handleChange: (donation: Donation) => void;
}

export const DonationAmount = ({
  codeDetails,
  settings,
  donation,
  currentDonationAmount,
  handleChange,
}: DonationAmountProps): React.JSX.Element | null => {
  let errorMessage = getDonationAmountErrors(
    donation.amount,
    settings.donationMinimum
  );
  const [amount, setAmount] = useState<string>(donation.amount.toString());

  return (
    <Grid size={{ xs: 12 }} container>
      <Grid size={{ xs: 12, sm: 4 }}>
        <TextField
          label="Donation"
          fullWidth={true}
          value={amount}
          error={errorMessage.length > 0}
          helperText={errorMessage}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            className: "tb_paper_input",
          }}
          onChange={(
            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
          ) => {
            let dollarFormat = /^([0-9]+(\.?[0-9]?[0-9]?)?)$/;
            if (
              event.target.value.length == 0 ||
              dollarFormat.test(event.target.value)
            ) {
              setAmount(event.target.value);
            }
          }}
          onBlur={() => {
            if (amount.length == 0 || Number.isNaN(amount)) {
              setAmount(donation.amount.toString());
            } else {
              let newAmount = Math.abs(parseFloat(amount));
              handleChange({
                ...donation,
                amount: newAmount,
              });
              setAmount(newAmount.toString());
            }
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 8 }} style={{ textAlign: "center" }}>
        <RedeemIcon />
        <Typography
          variant="body1"
          component="div"
          style={{
            display: "inline-block",
            lineHeight: "55px",
            paddingLeft: "8px",
            verticalAlign: "super",
          }}
        >
          {`${convertToCurrency(codeDetails.availableAmount)} Available`}
        </Typography>
        <Typography
          variant="body1"
          component="div"
          style={{
            display: "inline-block",
            lineHeight: "55px",
            paddingLeft: "6px",
            paddingRight: "6px",
            verticalAlign: "super",
          }}
        >
          |
        </Typography>
        <Typography
          variant="body1"
          component="div"
          style={{
            display: "inline-block",
            lineHeight: "55px",
            verticalAlign: "super",
          }}
        >
          {`${convertToCurrency(
            codeDetails.availableAmount -
              currentDonationAmount -
              donation.amount
          )} Remaining`}
        </Typography>
      </Grid>
    </Grid>
  );
};
